var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.09,
    height: 32.11,
    viewBox: "0 0 29.09 32.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3377",
    "data-name": "Path 3377",
    d: "M7.963,4.6v12.68a1.119,1.119,0,0,1-.746,1.044,1.044,1.044,0,0,1-.373.075H2.369A1.134,1.134,0,0,1,1.25,17.282V4.6A3.342,3.342,0,0,1,4.413,1.26h.194A3.356,3.356,0,0,1,7.963,4.6Z",
    transform: "translate(-1.25 -1.245)",
    fill: "#1b43ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M-885.634,10391.111a5.868,5.868,0,0,1-3.179-.933,3.361,3.361,0,0,0-1.946-.614h-.191a3.318,3.318,0,0,0-1.934.614l-.464.269a2.6,2.6,0,0,1-1.235.312,2.619,2.619,0,0,1-1.339-.369,2.622,2.622,0,0,1-1.273-2.24v-26.167A2.985,2.985,0,0,0-900,10359h17.35a8.54,8.54,0,0,1,6.061,2.516,8.539,8.539,0,0,1,2.517,6.063v20.555a2.617,2.617,0,0,1-1.273,2.24,2.607,2.607,0,0,1-1.339.37,2.626,2.626,0,0,1-1.238-.312l-.477-.269a3.2,3.2,0,0,0-1.888-.613l-.126,0-.117,0a3.253,3.253,0,0,0-1.927.628A5.859,5.859,0,0,1-885.634,10391.111Zm-5.221-12.718a1.12,1.12,0,0,0-1.119,1.119,1.12,1.12,0,0,0,1.119,1.118h5.967a1.12,1.12,0,0,0,1.119-1.118,1.12,1.12,0,0,0-1.119-1.119Zm0-5.967a1.12,1.12,0,0,0-1.119,1.119,1.12,1.12,0,0,0,1.119,1.118h10.442a1.12,1.12,0,0,0,1.119-1.118,1.12,1.12,0,0,0-1.119-1.119Zm0-5.967a1.12,1.12,0,0,0-1.119,1.119,1.12,1.12,0,0,0,1.119,1.118h10.442a1.12,1.12,0,0,0,1.119-1.118,1.12,1.12,0,0,0-1.119-1.119Z",
    transform: "translate(903.163 -10359)",
    fill: "#2b64fa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.dabc9140e58848992032eaaa98372334.svg";
export { ForwardRef as ReactComponent };